var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPappericon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9306 4.86692L48.0858 13.3522C47.9095 13.7412 47.8184 14.1633 47.8184 14.5904V52.4391C47.8184 53.5437 48.7138 54.4391 49.8184 54.4391H54.9537C56.0583 54.4391 56.9537 53.5437 56.9537 52.4391V14.5904C56.9537 14.1633 56.8625 13.7412 56.6863 13.3522L52.8415 4.86692C52.6641 4.4754 52.108 4.4754 51.9306 4.86692Z",
    stroke: "#D1B06B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8184 14.5903H52.957H56.9537",
    stroke: "#D1B06B",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.83398,
    y: 24.644,
    width: 28.0038,
    height: 2.33365,
    rx: 1.16683,
    fill: "#D1B06B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.16797,
    y: 8.47559,
    width: 10.1678,
    height: 7.83413,
    rx: 1.5,
    stroke: "#D1B06B",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.83398,
    y: 36.3125,
    width: 28.0038,
    height: 2.33365,
    rx: 1.16683,
    fill: "#D1B06B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.83398,
    y: 42.1465,
    width: 17.5024,
    height: 2.33365,
    rx: 1.16683,
    fill: "#D1B06B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.83398,
    y: 30.4785,
    width: 28.0038,
    height: 2.33365,
    rx: 1.16683,
    fill: "#D1B06B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8184 49.3306H56.9537",
    stroke: "#D1B06B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.30762V47.6925C1 51.5585 4.13401 54.6925 8 54.6925H34.2603C38.1263 54.6925 41.2603 51.5585 41.2603 47.6925V16.0358C41.2603 14.0484 40.4154 12.1546 38.9365 10.8269L30.3278 3.09866C29.0432 1.94548 27.3778 1.30762 25.6516 1.30762H8C4.13401 1.30762 1 4.44162 1 8.30762Z",
    stroke: "#D1B06B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9805 1.5249V11.1966C25.9805 13.4058 27.7713 15.1966 29.9805 15.1966H40.2898",
    stroke: "#D1B06B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPappericon);
export default __webpack_public_path__ + "static/media/pappericon.069cf404da7b0ccf20c785dca09960c5.svg";
export { ForwardRef as ReactComponent };